import { useMemo } from 'react';
import useFavoritedProductIds from 'hooks/useFavoritedProductIds';

const useProductListingWithFavorites = ({ products }) => {
  const { data } = useFavoritedProductIds();

  const productsToShowWithFavorites = useMemo(() => {
    const favoritedProductIds = data?.productIds ?? [];
    return products.map(product => ({
      ...product,
      isFavorited: favoritedProductIds.includes(product.id),
    }));
  }, [products, data]);

  return productsToShowWithFavorites;
};

export default useProductListingWithFavorites;
